<template>
  <div class="usuario-autocomplete">
    <v-autocomplete
      v-model="selectedUser"
      :items="users"
      :loading="loading"
      :search-input.sync="searchQuery"
      item-text="nome"
      item-value="id"
      label="Buscar usuário"
      placeholder="Digite o nome do usuário"
      return-object
      clearable
      no-filter
      hide-no-data
      hide-selected
      class="usuario-autocomplete__field"
      :menu-props="{ maxHeight: '200px', overflowY: 'auto' }"
      persistent-hint
      ref="autocomplete"
    >
      <template v-slot:item="{ item, on, attrs }">
        <div v-bind="attrs" v-on="on" class="v-list-item">
          <div class="v-list-item__content">
            <div class="v-list__tile__title">{{ item.nome }} - {{ item.email }}</div>
          </div>
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { actionTypes } from '@/commons/constants'

export default {
  name: 'UsuarioAutocomplete',
  props: {
    value: {
      type: Object,
      default: null
    },
    esclarecimentoImpugnacaoId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      selectedUser: null,
      users: [],
      loading: false,
      searchQuery: null
    }
  },
  watch: {
    selectedUser(newValue) {
      this.$emit('input', newValue)
    },
    searchQuery(val) {
      if (val && val.length >= 3) {
        this.searchUsers(val)
      } else {
        this.users = []
      }
    }
  },
  methods: {
    ...mapActions([
      actionTypes.BUSCAR_USUARIOS_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO
    ]),
    async searchUsers(query) {
      if (!query || query.length < 3) return
      this.loading = true
      try {
        const data = await this[actionTypes.BUSCAR_USUARIOS_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO]({
          esclarecimentoImpugnacaoId: this.esclarecimentoImpugnacaoId,
          nome: query,
          page: 0,
          size: 10
        })
        // Store the current search query to restore it later
        const currentQuery = this.searchQuery

        // Update the items list
        this.users = data.items || []

        // Use nextTick to ensure the DOM has updated
        this.$nextTick(() => {
          // Restore the search query and focus
          this.searchQuery = currentQuery

          // Focus the input element inside the autocomplete
          if (this.$refs.autocomplete) {
            const input = this.$refs.autocomplete.$el.querySelector('input')
            if (input) {
              input.focus()
            }
          }
        })
      } catch (error) {
        this.$emit('error', 'Erro ao buscar usuários')
      } finally {
        this.loading = false
      }
    },
    clear() {
      this.selectedUser = null
      this.searchQuery = null
      this.users = []
    }
  }
}
</script>

<style scoped>
.usuario-autocomplete__field {
    width: 100%;
}
</style>
